<template>
	<b-form @submit.stop.prevent="save($event); return false">
		<b-form-row class="mb-3">
			<b-col cols="12" lg="6">
				<b-card title="Alignment" class="mb-3">
					<b-form-row>
						<b-col cols="7">
							<b-form-group label="Horizontal">
								<b-button-group class="d-flex w-100">
									<b-button v-b-tooltip.hover.bottom title="Align left" :pressed="settings.textAlign == 'left'" @click="settings.textAlign = 'left'" variant="outline-secondary">
										<b-icon icon="align-start" aria-hidden="true"></b-icon>
									</b-button>
									<b-button v-b-tooltip.hover.bottom title="Align center" :pressed="settings.textAlign == 'center'" @click="settings.textAlign = 'center'" variant="outline-secondary">
										<b-icon icon="align-center" aria-hidden="true"></b-icon>
									</b-button>
									<b-button v-b-tooltip.hover.bottom title="Align right" :pressed="settings.textAlign == 'right'" @click="settings.textAlign = 'right'" variant="outline-secondary">
										<b-icon icon="align-end" aria-hidden="true"></b-icon>
									</b-button>
								</b-button-group>
							</b-form-group>
						</b-col>
						<b-col cols="5">
							<b-form-group label="Vertical">
								<b-button-group class="d-flex w-100">
									<b-button v-b-tooltip.hover.bottom title="Align top" :pressed="settings.verticalAlign == 'top'" @click="settings.verticalAlign = 'top'" variant="outline-secondary">
										<b-icon icon="align-top" aria-hidden="true"></b-icon>
									</b-button>
									<b-button v-b-tooltip.hover.bottom title="Align bottom" :pressed="settings.verticalAlign == 'bottom'" @click="settings.verticalAlign = 'bottom'" variant="outline-secondary">
										<b-icon icon="align-bottom" aria-hidden="true"></b-icon>
									</b-button>
								</b-button-group>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card title="Shape" class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="Left padding" append="px">
								<b-input-group append="px">
									<b-input type="number" min="0" max="2000" v-model="settings.paddingLeft"/>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group :label="settings.highlightedMessageAlign == 'top' ? 'Top padding' : 'Bottom padding'" append="px">
								<b-input-group append="px">
									<b-input type="number" min="0" max="2000" v-model="settings.paddingBottom"/>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Right padding" append="px">
								<b-input-group append="px">
									<b-input type="number" min="0" max="2000" v-model="settings.paddingRight"/>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card title="Animation" class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="In Transition">
								<b-form-select v-model="settings.inTransition" :options="inTransitions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Out Transition">
								<b-form-select v-model="settings.outTransition" :options="outTransitions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Animation duration" append="ms">
								<b-input-group append="ms">
									<b-form-input type="number" min="0" max="5000" v-model="settings.duration"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<text-settings :settings="settings" no-align />
				<b-card title="Colors" class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="Title text color">
								<color-picker v-model="settings.titleColor" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Title background">
								<color-picker v-model="settings.titleBg" />
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Message text color">
								<color-picker v-model="settings.textColor" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Message background">
								<color-picker v-model="settings.textBg" />
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Gift Text Color">
								<color-picker v-model="settings.giftColor" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Gift Background">
								<color-picker v-model="settings.giftBg" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card>
					<b-form-group label="Extra CSS">
						<b-textarea v-model="settings.extraCSS"></b-textarea>
					</b-form-group>
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<preview class="mb-3" slug="highlightedMessage" name="Highlighted Message" />
			</b-col>
		</b-form-row>
		<b-card class="text-center">
			<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
				<b-button variant="primary" type="submit">Save settings</b-button>
			</b-overlay>
		</b-card>
	</b-form>
</template>

<script>
import animateCssTransitions from '../../animateCssTransitions';
import ColorPicker from '@/components/ColorPicker.vue';
import Preview from '@/components/Widget/Preview.vue';
import TextSettings from '@/components/Widget/TextSettings.vue';

export default {
	data() { return {
		settings: {},
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		types: [ 'bubble', 'minimal', 'classic', 'block' ],
		verticalAligns: [ 'bottom', 'top' ],
		inTransitions: [ ...[{ text: 'No transition', value: null }], ...animateCssTransitions.inTransitions ],
		outTransitions: [ ...[{ text: 'No transition', value: null }], ...animateCssTransitions.outTransitions ],
		curColor: {},
		googleFonts: [],
		copyingStyle: false,
	}; },
	components: {
		ColorPicker,
		Preview,
		TextSettings,
	},
	async mounted() {
		try {
			this.saveError = null;
			this.error = null;
			this.loading++;
			const settings = await this.$api.get('widgetSettings/highlighted-message');
			this.settings = {
				...settings,
				type: settings.type || 'bubble',
				verticalAlign: settings.verticalAlign || 'bottom',
				inTransition: settings.inTransition||null,
				outTransition: settings.outTransition||null,
				titleColor: settings.titleColor || 'rgba(255, 255, 255, 1)',
				titleBg: settings.titleBg || 'rgba(0, 128, 0, 1)',
				textColor: settings.textColor || 'rgba(255, 255, 255, 1)',
				textBg: settings.textBg || 'rgba(0, 128, 0, 1)',
				giftColor: settings.giftColor || 'rgba(0, 0, 0, 1)',
				giftBg: settings.giftBg || 'rgba(255, 195, 0, 1)',
				fontFamily: settings.fontFamily || '',
				fontSize: settings.fontSize || 20,
				blurRadius: settings.blurRadius || 0,
				lineHeight: settings.lineHeight || 0,
				letterSpacing: settings.letterSpacing || 0,
				textAlign: settings.textAlign || 'left',
				boldText: settings.boldText || false,
				italicText: settings.italicText || false,
				underlineText: settings.underlineText || false,
				strikethroughText: settings.strikethroughText || false,
				uppercaseText: settings.uppercaseText || false,
				extraCSS: settings.extraCSS || '',
				customFont: settings.customFont || false,
				paddingLeft: settings.paddingLeft || 0,
				paddingBottom: settings.paddingBottom || 0,
				paddingRight: settings.paddingRight || 0,
			};
			this.googleFonts = await this.$api.get('googleFonts');
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async save() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('widgetSettings/highlighted-message', { ...this.settings });
			} catch(e) {
				console.error('Error saving widget:', e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
		async copyStyleFromChatWidget() {
			try {
				this.loading++;
				this.copyingStyle = true;
				this.error = null;
				const settings = await this.$api.get('widgetSettings/chat');
				this.settings.inTransition = settings.inTransition;
				this.settings.outTransition = settings.outTransition;
				this.settings.duration = settings.duration;
				this.settings.blurRadius = settings.blurRadius || 0;
				this.settings.spreadRadius = settings.spreadRadius || 0;
				this.settings.boldText = settings.boldText || false;
				this.settings.extraCSS = settings.extraCSS || '';
				this.settings.fontFamily = settings.fontFamily || '';
				this.settings.fontSize = settings.fontSize || 20;
				this.settings.italicText = settings.italicText || false;
				this.settings.letterSpacing = settings.letterSpacing || 0;
				this.settings.lineHeight = settings.lineHeight || 0;
				this.settings.shadowColor = settings.shadowColor ||  'rgba(0, 0, 0, 1)';
				this.settings.strikethroughText = settings.strikethroughText || false;
				this.settings.textAlign = settings.textAlign || 'left';
				this.settings.textBg = settings.textBg || 'rgba(0, 128, 0, 0)';
				this.settings.textColor = settings.textColor || 'rgba(255, 255, 255, 1)';
				this.settings.underlineText = settings.underlineText || false;
				this.settings.customFont = settings.customFont || false;
			} catch(e) {
				this.error = e;
			} finally {
				this.copyingStyle = false;
				this.loading--;
			}
		},
	},
};
</script>
